__turbopack_context__.v({
  "badge": "multiple-selector-module__sFMOHq__badge",
  "badgeRemove": "multiple-selector-module__sFMOHq__badgeRemove",
  "chevronButton": "multiple-selector-module__sFMOHq__chevronButton",
  "chevronIcon": "multiple-selector-module__sFMOHq__chevronIcon",
  "chevronOpen": "multiple-selector-module__sFMOHq__chevronOpen",
  "empty": "multiple-selector-module__sFMOHq__empty",
  "icon": "multiple-selector-module__sFMOHq__icon",
  "input": "multiple-selector-module__sFMOHq__input",
  "label": "multiple-selector-module__sFMOHq__label",
  "list": "multiple-selector-module__sFMOHq__list",
  "option": "multiple-selector-module__sFMOHq__option",
  "optionCheck": "multiple-selector-module__sFMOHq__optionCheck",
  "optionCheckIcon": "multiple-selector-module__sFMOHq__optionCheckIcon",
  "optionCheckSelected": "multiple-selector-module__sFMOHq__optionCheckSelected",
  "optionHighlighted": "multiple-selector-module__sFMOHq__optionHighlighted",
  "optionLabel": "multiple-selector-module__sFMOHq__optionLabel",
  "optionSelected": "multiple-selector-module__sFMOHq__optionSelected",
  "popover": "multiple-selector-module__sFMOHq__popover",
  "popoverInner": "multiple-selector-module__sFMOHq__popoverInner",
  "popoverListScroll": "multiple-selector-module__sFMOHq__popoverListScroll",
  "trigger": "multiple-selector-module__sFMOHq__trigger",
  "triggerDisabled": "multiple-selector-module__sFMOHq__triggerDisabled",
  "triggerScroll": "multiple-selector-module__sFMOHq__triggerScroll",
  "triggerWrapper": "multiple-selector-module__sFMOHq__triggerWrapper",
  "wrapper": "multiple-selector-module__sFMOHq__wrapper",
});
